
import React, { Component } from 'react';

//reactstrap
import { Container, Row, Col, Card, CardImg, Button } from 'reactstrap';

//styles
import './Productos.scss';

//ajax
import { Stand, Impresionn, puntoAtencion, MesaCentro } from './product';

//imagenes productos

class Productos extends Component {
  constructor(props){
    super(props);
    this.state = {
      wi: 12
    }
    
//    window.onscroll = () =>{
//      if(window.scrollY > 20){
        //console.log('datos de pruebas');
        //window.scrollTo("0","0");
        //window.location.reload(); 
//      }else{
        //console.log('datos no compilados');
//      }
//    }
  }
    //  handlescroll(event){
    //    console.log('datos de prue ', event)
    //}
  render() {
      return (
        <div className={"divproductos"} >
        <Container>
          <h1>Nuestros Productos</h1>
          <Row>
            {MesaCentro.map((prod, index)=>{
              return(
                <Col md="4" sm="4" xs="12" key={index}>
                  <Card className={"productosDiv"} >
                    <CardImg className={"productos"} src={prod.img} key={index} ></CardImg>
                    <h1 key={prod.toString()} >{prod.name}</h1>
                    <Button className={"BtnCotizar"} >Cotizar</Button>
                  </Card>
                </Col>
              )
            })}
          </Row>
          <Row>
            {Stand.map((prod, index)=>{
              return(
                <Col md="4" sm="4" xs="12" key={index}>
                  <Card className={"productosDiv"} >
                    <CardImg className={"productos"} src={prod.img} key={index} ></CardImg>
                    <h1 key={prod.toString()} >{prod.name}</h1>
                    <Button className={"BtnCotizar"} >Cotizar</Button>
                  </Card>
                </Col>
              )
            })}
          </Row>
          <Row>
            {puntoAtencion.map((prod, index)=>{
              return(
                <Col md="4" sm="4" xs="12" key={index}>
                  <Card className={"productosDiv"} >
                    <CardImg className={"productos"} src={prod.img} key={index} ></CardImg>
                    <h1 key={prod.toString()} >{prod.name}</h1>
                    <Button className={"BtnCotizar"} >Cotizar</Button>
                  </Card>
                </Col>
              )
            })}
          </Row>

          <Row>
            {Impresionn.map((prod, index)=>{
              return(
                <Col md="4" sm="4" xs="12" key={index}>
                  <Card className={"productosDiv"} >
                    <CardImg className={"productos"} src={prod.img} key={index} ></CardImg>
                    <h1 key={prod.toString()} >{prod.name}</h1>
                    <Button className={"BtnCotizar"} >Cotizar</Button>
                  </Card>
                </Col>
              )
            })}
          </Row>
          
        </Container>
      </div>
    )
  }
}
export default Productos;



// WEBPACK FOOTER //
// ./src/Pages/Productos/Productos.jsx